module.exports = __webpack_public_path__ + "img/cocobank-logo.5efef488.png";